/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>base.communication.service.ts</name>
///
/// <description>
///  The concrete communication service for Hydrogen Cloud
///  
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>15 Sept 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Injectable, Input }  from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';  
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import {MockBackend} from '@angular/http/testing';
  
 

@Injectable()
export class BaseCommunicationService   {
      
    private baseUrl: string = "http://localhost:3000/";
    ngOnChanges() { };
    ngDoCheck() { };
    ngAfterContentInit() { };
    ngAfterContentChecked() { };
    ngAfterViewInit() { };
    ngAfterViewChecked() { };

    constructor(
        protected http: Http  
    ) {

    }
    //----------------------------------------------------------
    //ngOnInit
    //----------------------------------------------------------
    ngOnInit() { 
         
 
    } 
    //----------------------------------------------------------
    //ngOnDestroy
    //----------------------------------------------------------
    ngOnDestroy() {
      

    } 
 

   
    //----------------------------------------------- 
    // getViewModel
    //-----------------------------------------------  
    getViewModel(): Observable<any> {

        let headers = new Headers({ 'Accept': 'application/json' });
        let options = new RequestOptions({ headers: headers });
       
        return this.http.get('app/models/base-view-models/base-view-model.json', options).map((res: Response) => res.json())
        

    }
     

    //----------------------------------------------- 
    // getData
    //-----------------------------------------------  
    getData(cid: string): Observable<any> {

        let headers = new Headers({ 'Accept': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        return this.http.get('app/models/base-payloads/base-payload.json', options).map((res: Response) => res.json())


    }
    
   

  
    
}
 


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/features/base-component/base-communication.service.ts